
/**
 * Encode tabs values for editable table
 */
export function encodeTabs(data) {
    var dataTabs = [];

    for (var key in data) {
        dataTabs.push({ 'name': key, 'field': data[key] });
    }

    return dataTabs;
}



/**
 * Decode tabs values from editable table
 */
export function decodeTabs(data) {
    var dataTabs = {};

    for (var k = 0; k < data.length; k++) {
        dataTabs[data[k].name] = data[k].field;
    }

    return dataTabs;
}